export const featuredPortfolio = [
    {
      id: 1, 
      title: "Encrypted Banking App",
      img:
        "./assets/myapp.png",
    },
    {
      id: 2,
      title: "Virtual Reality Unity 3D App",
      img:
        "./assets/arvr.png",
    },
    {
      id: 3,
      title: "Encrypted Banking Website",
      img:
        "./assets/websitepro.png",
    },
    {
      id: 4,
      title: "Attendance Analyzer",
      img:
        "./assets/attendance.jpg",
    },
    {
      id: 5,
      title: "Garbage Collection App",
      img:
        "./assets/garbage.png",
    },
    {
      id: 6,
      title: "Finaaz Blog Designs",
      img:
        "./assets/finaaz.png",
    },
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "Encrypted Banking Website",
      img:
        "./assets/websitepro.png",
      },
    {
      id: 2,
      title: "Responsive ReactJs Portfolio",
      img: "./assets/portweb.png",
    },
    {
      id: 3,
      title: "College Fest Website",
      img:
        "./assets/xact.png",
    },
  ];
  
  export const mobilePortfolio = [
    {
      id: 1,
      title: "Encrypted Banking App",
      img:
        "./assets/myapp.png",
    },
    {
      id: 2,
      title: "Virtual Reality Unity 3D App",
      img:
        "./assets/arvr.png",
    },
    {
      id: 3,
      title: "Garbage Collection App",
      img:
        "./assets/garbage.png",
    },
  ];
  
  export const designPortfolio = [
    {
      id: 1,
      title: "Docta App Web Design",
      img:
        "./assets/docta.png",
    },
    {
      id: 2,
      title: "DataFusion B2B Designs",
      img:
        "./assets/datafusion.png",
    },
    {
      id: 3,
      title: "Finaaz Blog Designs",
      img:
        "./assets/finaaz.png",
    },
    {
      id: 4,
      title: "TryMe Furnishing Design Work",
      img:
        "./assets/tryme.png",
    },
    {
      id: 5,
      title: "24SkyWave WetWipes Design",
      img:
        "./assets/wetwipe.png",
    },
  ];
  
  export const contentPortfolio = [
    {
      id: 1,
      title: "CodeChef : 1673 Rating",
      img:
        "./assets/codechef.png",
    },
    {
      id: 2,
      title: "LeetCode : 100+ Problems",
      img:
        "./assets/leet.png",
    },
    {
      id: 3,
      title: "HackerRank : 6 Star",
      img:
        "./assets/hacker.png",
    },
    {
      id: 4,
      title: "GeeksforGeeks : 100+ Problems",
      img:
        "./assets/geeks.png",
    },
  ];
  